import L from 'leaflet';
import { FunctionComponent } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import ArchivedSdnBoxBackedL3ServiceIcon from '../../../../assets/images/icons/sdnbox-topology/sdnbox-archived.svg';
import AvailableSdnBoxBackedL3ServiceIcon from '../../../../assets/images/icons/sdnbox-topology/sdnbox-available.svg';
import PendingSdnBoxBackedL3ServiceIcon from '../../../../assets/images/icons/sdnbox-topology/sdnbox-pending.svg';
import ReadySdnBoxBackedL3ServiceIcon from '../../../../assets/images/icons/sdnbox-topology/sdnbox-ready.svg';
import UnavailableSdnBoxBackedL3ServiceIcon from '../../../../assets/images/icons/sdnbox-topology/sdnbox-unavailable.svg';
import { L3ServiceLocationViewModel, MaintenanceStatus } from '../../model';
import { L3ServiceMarkerContainer } from '../L3ServiceMarkerContainer/L3ServiceMarkerContainer';
import { L3ServiceStatus } from '../../../l3-services/model';

export const TopologyMarkerIcon = (location: L3ServiceLocationViewModel): L.DivIcon => {
  const DivIconWithLocation = L.DivIcon.include({ location });

  return new DivIconWithLocation({
    html: renderToStaticMarkup(<TopologyMarker location={location} />),
    // adding this class prevents leaflet from applying its default styles
    className: 'custom-marker-icon',
    iconSize: [24, 40],
    iconAnchor: [12, 40],
    location
  });
};

interface Props {
  location: L3ServiceLocationViewModel;
}

const TopologyMarker: FunctionComponent<Props> = ({ location }) => {
  const iconUrl = getServiceIconUrl(location.serviceStatus);
  const displayNotificationsIcon = Boolean(location.notificationCount);
  const displayActiveMaintenanceWorksIcon = location.maintenanceStatuses?.includes(MaintenanceStatus.Active);
  const displayPlannedMaintenanceWorksIcon = location.maintenanceStatuses?.includes(MaintenanceStatus.Planned)
    && !location.maintenanceStatuses?.includes(MaintenanceStatus.Active);

  return <L3ServiceMarkerContainer
    displayActiveMaintenanceWorksIcon={displayActiveMaintenanceWorksIcon}
    displayPlannedMaintenanceWorksIcon={displayPlannedMaintenanceWorksIcon}
    displayNotificationsIcon={displayNotificationsIcon}
  >
    <img
      src={iconUrl}
      alt={location.serviceName}
    />
    <span style={{ textAlign: 'center', fontWeight: 'bold' }}>{location.orderNumber}</span>
  </L3ServiceMarkerContainer>;
};

const getServiceIconUrl = (serviceStatus: L3ServiceStatus): string => {
  switch (serviceStatus) {
    case L3ServiceStatus.Archived:
      return ArchivedSdnBoxBackedL3ServiceIcon;
    case L3ServiceStatus.Available:
      return AvailableSdnBoxBackedL3ServiceIcon;
    case L3ServiceStatus.Pending:
      return PendingSdnBoxBackedL3ServiceIcon;
    case L3ServiceStatus.Ready:
      return ReadySdnBoxBackedL3ServiceIcon;
    case L3ServiceStatus.Unavailable:
      return UnavailableSdnBoxBackedL3ServiceIcon;
  }
};